import React, { useState, useEffect } from 'react';
import PasswordConfirm from './PasswordConfirm';
import ForgotPassword from './ForgotPassword';
import { Box } from '@mui/material';
import { forget_password } from '../../api';
import { useDispatch } from 'react-redux';
import { setSnackDetails, setMetaData } from '../../service/actions/common';
import validator from "validator";

const ResetPass = () => {
    const dispatch = useDispatch();
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const metaData  = {
      title: 'Reset Password | InspectReply AI',
      description: 'Reset Password | InspectReply AI'
    };

    const switchToPasswordConfirm = async (e) => {
      try {
          if (email === '') {
            dispatch(setSnackDetails({openState : true, message : "*Email is required to reset password", severity : 'error'}));
            return;
          }
          if (! validator.isEmail(email) ) {
            dispatch(setSnackDetails({openState : true, message : "*Please check your entry and try again", severity : 'error'}));
            return;
          }

          console.log(email);
          // call API to send email and get status  based on that status switch the view.
          const { data } = await forget_password({ email });
          dispatch(setSnackDetails({openState : true, message : data.message, severity : 'success'}));
          setIsLogin(false);
        } catch (error) {
          dispatch(setSnackDetails({openState : true, message : error.response.data.message, severity : 'error'}));
          console.error(error);
        }
    };
    useEffect(() => {
		dispatch(setMetaData(metaData));
		// eslint-disable-next-line
	}, []);

  return (
      <Box>
          {isLogin ? (
            <ForgotPassword switchToPasswordConfirm={switchToPasswordConfirm} setEmail={setEmail} />
          ) : (
            <PasswordConfirm value={email} />
          )}
      </Box>
  );
};

export default ResetPass;
